/* eslint-disable array-callback-return */
import { useEffect, useRef, useState } from "react";
import { Pagination, Tooltip, Whisper } from "rsuite";
import Constants from "utils/constants";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import axios from "axios";

import {
  Button,
  CheckPicker,
  Checkbox,
  DateRangePicker,
  Drawer,
  Dropdown,
  PickerHandle,
  Modal,
} from "rsuite";

const TableComponentforEquipment = (props: any) => {
  const {
    userContext = {},
    userStore,
    isFromModal,
    tableDetails,
    reportList,
    iconColumn,
    onTableRowClick,
    totalTableRow,
    isTotalRowRequired,
    DisplayNoDatatlabel,
    showAll,
    handleShowAll,
    selectedtab,
    isTableCustomStriped,
  } = props;

  const [open, setOpen] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortType, setSortType] = useState("asc");
  const [limit, setLimit] = useState(50);
  const [page, setPage] = useState(1);
  const scrollRef = useRef(null);
  const [equipmentName, setEquipmentName] = useState("");
  const [serialName, setSerialName] = useState("");
  const [textAreaLabel, setTextAreaLabel] = useState("");
  const [userNameData, setUserNameData] = useState("");
  const [nameSplit, setNameSplit] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [ticketId, setTicketId] = useState(null);
  const [ordersData, setOrdersData] = useState(null);

  useEffect(() => {
    if (userContext) {
      setEmailAddress(userContext.email);
      setUserNameData(userContext.userName);
    }
  }, [userContext]);

  useEffect(() => {
    setNameSplit(userNameData.split(" "));
  }, [userNameData]);
  const ticketCategories = [
    {
      id: 1,
      name: "GL",
    },
    {
      id: 2,
      name: "Payroll",
    },
    {
      id: 3,
      name: "IT",
    },
  ];

  /*   const onSubmit = (data) => {
    if (!data.serviceDescription || !data.phoneNumber || !selectedValue) {
      setSubmitted(true);
      console.log("if cond", data);
    } else {
      console.log("else cond", data);
      const payload = {
        fields: {
          project: {
            key: "FPH",
          },
          summary: data.serviceDescription,
          description: "Creating of an issue using project keys and issue type names using the REST API",
          customfield_10191: selectedValue,
          customfield_10179: data.firstName,
          customfield_10180: data.lastName,
          customfield_10181: data.emailAdress,
          customfield_10182: data.phoneNumber,
          customfield_10183: data.serviceDescription,
          issuetype: {
            name: "Task",
          },
        },
      };

      console.log("payload :", payload);
      getBearerToken().then((accessTokenResponse) => {
        const token = accessTokenResponse;
        const headers = { Authorization: `Bearer ${token}` };
        axios
          .post('https://fms-api-mgmt-gway01.azure-api.net/portalapi/api/TicketMgmt/PostTicketDetails', payload, { headers })
          .then((response) => {
            console.log("response", response);
            setOrdersData(response.data);
            setTicketId(response.data.id);
            // Reset the form
            // this.profileForm.reset(); // Bu Angular'daki bir özelliktir, React'te formu yönetmek için başka bir yaklaşım kullanırız
            if (ticketId) {
              setDisplayStyle("block");
              setErrMsg(true);
              console.log("order data", ticketId);
            } else {
              setDisplayStyle("none");
              setErrMsg(false);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    }
  }; */

  const handleOpen = () => {
    if (textAreaLabel) {
      //********************* */
      const payload = {
        email112: "awgsupport@fmssolutions.com",
        token112:
          "ATATT3xFfGF0BwokFXR9giKaZwcBc7XaiA1p21-snwkSedZ7eH9DVEYcPhashQBpXNm-DrzEE2qP0q2vbSCQ2xJTY1HmhUd-3igDrE0ni379I0yFriMRa6EQfzx2gva-5JYfFgErZCDzL5cdi_M1OeElTNQldVR0FL-nZuA8WaUBlEsMSlet1OA=27D0B12D",
        fields: {
          project: {
            key: "AWG",
          },

          summary: `Store ID: ${
            userContext && userContext.store ? userContext.store : userStore
          } / Equipment: ${equipmentName} / Serial No: ${serialName}`,
          //description: textAreaLabel,
          description: textAreaLabel,
          /*           customfield_10191: "Equipment Support",
          customfield_10179: nameSplit[0],
          customfield_10180: nameSplit[1],
          customfield_10181: emailAddress,
          customfield_10182: null,
          customfield_10183: null, */
          //customfield_10041:emailAddress,
          // customfield_10041: [
          //   /*             {
          //     self: "https://fmssolutions.atlassian.net/rest/api/2/user?accountId=qm%3A56ac9f09-5c97-4cef-809f-f28f6e19c497%3A7b51bc14-6c8e-4ca2-b030-767fbb40133b",
          //     key: "qm:56ac9f09-5c97-4cef-809f-f28f6e19c497:7b51bc14-6c8e-4ca2-b030-767fbb40133b",
          //     accountId:
          //       "qm:56ac9f09-5c97-4cef-809f-f28f6e19c497:7b51bc14-6c8e-4ca2-b030-767fbb40133b",
          //     emailAddress: "mirac.karayel@fmssolutions.com",

          //     displayName: "Mirac.Karayel@fmssolutions.com",
          //     active: true,
          //     timeZone: "America/New_York",
          //     accountType: "customer",
          //   }, */
          //   // {
          //   //   self: "https://fmssolutions.atlassian.net/rest/api/2/user?accountId=qm%3A56ac9f09-5c97-4cef-809f-f28f6e19c497%3A7b51bc14-6c8e-4ca2-b030-767fbb40133b",
          //   //   key: "qm:56ac9f09-5c97-4cef-809f-f28f6e19c497:7b51bc14-6c8e-4ca2-b030-767fbb40133b",
          //   //   accountId:
          //   //     "qm:56ac9f09-5c97-4cef-809f-f28f6e19c497:7b51bc14-6c8e-4ca2-b030-767fbb40133b",
          //   //   emailAddress: emailAddress.toLowerCase(),

          //   //   displayName: emailAddress,
          //   //   active: true,
          //   //   timeZone: null,
          //   //   accountType: null,
          //   // },

          //   {
          //     self: "https://fmssolutions.atlassian.net/rest/api/2/user?accountId=712020%3Ac04e7a20-1e02-4444-bd71-27e235ec2a4d",
          //     key: "712020%3Ac04e7a20-1e02-4444-bd71-27e235ec2a4d",
          //     accountId: "712020%3Ac04e7a20-1e02-4444-bd71-27e235ec2a4d",
          //     emailAddress: "awgsupport@fmssolutions.com".toLowerCase(),
          //     displayName: "awgsupport@fmssolutions.com",
          //     active: true,
          //     timeZone: null,
          //     accountType: null,
          //   },
          // ],

          issuetype: {
            name: "IT Help",
          },
        },
      };

      const headers = { Authorization: `Bearer ${userContext.token}` };

      axios
        .post(
          "https://api.gotsystems.net/api/TicketMgmt/PostTicketDetails",
          payload,
          { headers }
        )
        .then((response) => {
          setOrdersData(response.data);
          setTicketId(response.data.id);
        })
        .catch(function (error) {
          console.log(error);
        });

      //********************* */
      toast.success("Email Send Successfully");
      setTextAreaLabel("");
    }

    setOpen(false);
  };

  const handleClose = () => {
    setTextAreaLabel("");
    setOpen(false);
  };

  const sendEmail = (event) => {
    const frameZones = Array.from(document.querySelectorAll("td"));
    var tdsWithId1 = frameZones.filter(function (td) {
      return td.id === event.target.id;
    });

    var innerTexts = tdsWithId1.map(function (td) {
      return td.innerText;
    });
    handleOpen();
    setOpen(true);

    setEquipmentName(innerTexts[1]);
    setSerialName(innerTexts[0]);
  };

  const textAreaInput = (event) => {
    setTextAreaLabel(event.target.value);
  };

  useEffect(() => {
    setSortColumn("");
    setSortType("asc");
    setPage(1);
  }, [tableDetails]);

  useEffect(() => {
    setPage(1);
  }, [reportList]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
      scrollRef.current.scrollLeft = 0;
    }
  }, [tableDetails, page]);

  const data =
    reportList &&
    reportList.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
  //#region  Table Sort
  const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn] ? a[sortColumn] : "";
        let y = b[sortColumn] ? b[sortColumn] : "";
        if (sortType === "asc") {
          return x
            .toString()
            .localeCompare(y.toString(), undefined, { numeric: true });
        } else {
          return y
            .toString()
            .localeCompare(x.toString(), undefined, { numeric: true });
        }
      });
    }
    return data;
  };

  const handleSortColumn = (_sortColumn) => {
    setSortColumn(_sortColumn);
    const _sortType =
      _sortColumn === sortColumn
        ? sortType === "asc"
          ? "desc"
          : "asc"
        : "asc";
    setSortType(_sortType);
    // ? why timeout?
    // setLoading(true);
    setTimeout(() => {
      // setLoading(false);
    }, 500);
  };
  //#endregion

  //#region Pagination
  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };
  //#endregion

  const hoverData = (hData) => {
    switch (hData) {
      case "D":
        return "Default";
      case "M":
        return "Manual Price";

      default:
        return "Percent";
    }
  };

  const getRowColor = (_result, _Idx, colorToggle, setClrToggle) => {
    let classname = "";
    if (_Idx === 0) {
      classname = "table-row-blue";
    } else {
      if (_result["store_ID"] !== getData()[_Idx - 1]["store_ID"]) {
        classname = "table-row-blue";
        setClrToggle && setClrToggle(!colorToggle);
      } else {
        classname = colorToggle ? "table-row-gray" : "";
      }
    }
    return classname;
  };

  const RenderTableHeaders = () => {
    let currentColWidth = 0;
    let subHeaderColWidth = 0;
    return (
      <>
        {" "}
        <tr>
          {tableDetails &&
            tableDetails.map((item, _idx) => {
              //console.log(item);
              if (item.isHeader && !item.isSubHeader) {
                const thCell = (
                  <th
                    rowSpan={item.colSpan > 1 ? 1 : 2}
                    colSpan={item.colSpan}
                    className={`filterHeader ${
                      item.TypeOfData === "Price"
                        ? "text-end pe-4"
                        : item.TypeOfData === "Number" ||
                          item.TypeOfData === "text-center" ||
                          item.TypeOfData === "text-center-heading"
                        ? "text-center pe-4"
                        : ""
                    } ${
                      item.colSpan > 1
                        ? "text-center pe-4 table-border-header"
                        : ""
                    } ${item.isFixed ? "fixed-column" : ""}`}
                    style={{
                      minWidth: item.Width,
                      left: item.isFixed ? currentColWidth : "inherit",
                    }}
                  >
                    <span
                      onClick={() => {
                        item.isSortable && handleSortColumn(item.DataKey);
                      }}
                      title={
                        item.Header === "Theft"
                          ? "Product was stolen and package was found empty"
                          : item.Header === "Out Of Date"
                          ? "Product thrown out due to being past expiration date"
                          : item.Header === "Recovery"
                          ? "Extra Product used to make product sold by weight"
                          : null
                      }
                    >
                      {}
                      {item.Header}
                      {item.isSortable && sortColumn !== item.DataKey && (
                        <Icon className="ms-1" icon="ep:sort" />
                      )}
                      {item.isSortable && sortColumn === item.DataKey && (
                        <>
                          {sortType === "asc" && (
                            <Icon
                              className="ms-1"
                              icon="material-symbols:arrow-upward-rounded"
                            />
                          )}
                          {sortType === "desc" && (
                            <Icon
                              className="ms-1"
                              icon="material-symbols:arrow-downward-rounded"
                            />
                          )}
                        </>
                      )}
                    </span>
                  </th>
                );
                currentColWidth += item.Width;
                return thCell;
              }
            })}
        </tr>
        {tableDetails &&
          tableDetails.some((_items) => {
            return _items.isHeader;
          }) && (
            <tr>
              {tableDetails &&
                tableDetails.map((item, _idx) => {
                  if (item.isSubHeader) {
                    const thCell = (
                      <th
                        className={`filterHeader table-border-subheader ${
                          item.TypeOfData === "Price"
                            ? "text-end pe-4"
                            : "text-center pe-4"
                        } ${item.isFixed ? "fixed-column" : ""}`}
                        style={{
                          minWidth: item.Width,
                          left: item.isFixed ? subHeaderColWidth : "inherit",
                        }}
                      >
                        <span
                          onClick={() => {
                            item.isSortable && handleSortColumn(item.DataKey);
                          }}
                          title={
                            item.Header === "Theft"
                              ? "Product was stolen and package was found empty"
                              : item.Header === "Out Of Date"
                              ? "Product thrown out due to being past expiration date"
                              : item.Header === "Recovery"
                              ? "Extra Product used to make product sold by weight"
                              : null
                          }
                        >
                          {item.Header}
                          {item.isSortable && sortColumn !== item.DataKey && (
                            <Icon icon="ep:sort" />
                          )}
                          {item.isSortable && sortColumn === item.DataKey && (
                            <>
                              {sortType === "asc" && (
                                <Icon icon="material-symbols:arrow-upward-rounded" />
                              )}
                              {sortType === "desc" && (
                                <Icon icon="material-symbols:arrow-downward-rounded" />
                              )}
                            </>
                          )}
                        </span>
                      </th>
                    );
                    subHeaderColWidth += item.Width;
                    return thCell;
                  }
                })}
            </tr>
          )}
      </>
    );
  };

  const RenderTableRows = () => {
    if (reportList && reportList.length > 0) {
      let colorToggle = true;
      return getData().map((_result, _Idx) => {
        let currentColWidth = 0;
        return (
          <>
            <tr
              className={
                isTableCustomStriped &&
                getRowColor(_result, _Idx, colorToggle, (res) => {
                  colorToggle = res;
                })
              }
              style={{
                fontWeight:
                  _result["isbold"] && _result["isbold"] ? "bold" : "normal",
                borderTop:
                  isTableCustomStriped && _Idx === 0
                    ? "2px solid #3298e9"
                    : isTableCustomStriped &&
                      _result["store_ID"] !== getData()[_Idx - 1]["store_ID"]
                    ? "2px solid #3298e9"
                    : "",
              }}
              key={`TableRows${_Idx}`}
              onClick={() => onTableRowClick(_result)}
            >
              {/*               <button id={_Idx} onClick={sendEmail} className="reportButton">
                Report an issue for this equipment
              </button> */}
              {tableDetails &&
                tableDetails.map((item) => {
                  if (item.isHeader && item.colSpan === 1) {
                    const tdCell = (
                      <td
                        id={_Idx}
                        colSpan={1}
                        className={`${
                          item.TypeOfData === "Price"
                            ? "text-end pe-4"
                            : item.TypeOfData === "Number" ||
                              item.TypeOfData === "text-center"
                            ? "text-center pe-4"
                            : ""
                        } ${item.isFixed ? "fixed-column" : ""}`}
                        style={{
                          minWidth: item.Width,
                          left: item.isFixed ? currentColWidth : "inherit",
                        }}
                      >
                        {iconColumn &&
                          iconColumn !== "" &&
                          iconColumn === item.DataKey && (
                            <Icon
                              className="icon-size"
                              icon="ic:outline-remove-red-eye"
                            />
                          )}

                        <span>
                          {item.Icon !== "" &&
                            item.DataKey === "price_Adj" &&
                            _result[item.Icon] > 0 && (
                              <Whisper
                                placement="bottom"
                                controlId="control-id-hover"
                                trigger="hover"
                                speaker={
                                  <Tooltip>Manual Price Entered </Tooltip>
                                }
                              >
                                <Icon
                                  className=" ms-3 flag-icon2 on-hover "
                                  icon="ep:flag"
                                />
                              </Whisper>
                            )}
                        </span>

                        <span>
                          {item.Icon !== "" &&
                            (item.DataKey === "reg_Price" ||
                              item.DataKey === "total") &&
                            _result[item.Icon] > 0 && (
                              <Whisper
                                placement="bottom"
                                controlId="control-id-hover"
                                trigger="hover"
                                speaker={<Tooltip>Regular Price Keyed</Tooltip>}
                              >
                                <Icon
                                  className="flag-icon2 on-hover"
                                  icon="ep:flag"
                                />
                              </Whisper>
                            )}
                        </span>

                        <span>
                          {item.Icon !== "" &&
                            item.DataKey === "CleanWithFlag" &&
                            _result[item.Icon] > 0 && (
                              <Whisper
                                placement="bottom"
                                controlId="control-id-hover"
                                trigger="hover"
                                speaker={<Tooltip>Quick Cleaned</Tooltip>}
                              >
                                <Icon
                                  className="flag-icon3 on-hover "
                                  icon="ep:flag"
                                />
                              </Whisper>
                            )}
                        </span>

                        <span>
                          {item.Icon !== "" &&
                            item.DataKey === "days_Old" &&
                            _result[item.Icon] > 0 &&
                            _result["Badge_Type"] &&
                            _result["Badge_Type"] !== "Without Badge" &&
                            _result["Badge_Type"] !== "No" && (
                              <Whisper
                                placement="bottom"
                                controlId="control-id-hover"
                                trigger="hover"
                                speaker={<Tooltip>Previously Used </Tooltip>}
                              >
                                <Icon
                                  className=" flag-icon3 on-hover "
                                  icon="ep:flag"
                                />
                              </Whisper>
                            )}
                        </span>

                        <span>
                          {item.DataKey !== "label_Type" ? (
                            item.TypeOfData === "Price" ? (
                              "$" +
                              (_result[item.DataKey]
                                ? Number(_result[item.DataKey])
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "0.00")
                            ) : (
                              _result[item.DataKey]
                            )
                          ) : (
                            <Whisper
                              followCursor
                              placement="bottom"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {hoverData(_result[item.DataKey])}
                                </Tooltip>
                              }
                            >
                              <span>
                                {item.TypeOfData === "Price"
                                  ? "$" +
                                    (_result[item.DataKey]
                                      ? Number(_result[item.DataKey])
                                          .toFixed(2)
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : "0.00")
                                  : _result[item.DataKey]}
                              </span>
                            </Whisper>
                          )}
                        </span>
                        <span>
                          {item.DataKey === "Report" && (
                            // <button
                            //id={_Idx}
                            //onClick={sendEmail} */
                            //className="reportButton"
                            //</span>>
                            //</button>

                            <Icon
                              id={_Idx}
                              onClick={sendEmail}
                              className="icon-size"
                              icon="ic:outline-report"
                            />
                          )}
                        </span>
                      </td>
                    );

                    currentColWidth += item.Width;
                    return tdCell;
                  }
                })}
              {/*               <button id={_Idx} onClick={sendEmail} className="reportButton">
                Report an issue
              </button> */}
            </tr>
          </>
        );
      });
    }
  };

  return (
    <>
      <Modal
        open={open}
        backdrop={"static"}
        keyboard={false}
        onClose={handleClose}
        size="full"
      >
        <Modal.Header>
          <Modal.Title>
            {userContext ? (
              /*  Store ID:  / Equipment: ${equipmentName} / Serial No: ${serialName} */
              <div>
                Store ID:{" "}
                <span style={{ fontWeight: 700 }}>
                  {userContext && userContext.store
                    ? userContext.store
                    : userStore}
                </span>{" "}
                / Equipment:{" "}
                <span style={{ fontWeight: 600 }}>{equipmentName}</span>. /
                Serial No: <span style={{ fontWeight: 600 }}>{serialName}</span>
                .
              </div>
            ) : (
              ""
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <textarea
            onChange={textAreaInput}
            id="textarea"
            name="textarea"
            rows={10}
            cols={200}
            placeholder="Write Your Description."
          ></textarea>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleOpen} appearance="primary">
            Ok
          </Button>
          <Button onClick={handleClose} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {reportList && reportList.length >= 0 ? ( // && reportList.length > 0
        <div>
          <div
            ref={scrollRef}
            className={`mt-3 tableContainer table-scroll ${
              isFromModal ? "modal-table" : ""
            }`}
          >
            <table
              className={`table ${isTableCustomStriped ? "" : "table-striped"}`}
            >
              <thead>{RenderTableHeaders()}</thead>
              <tbody>{RenderTableRows()}</tbody>
              {isTotalRowRequired && (
                <tfoot>
                  <tr
                    className={`${showAll ? "showAll" : ""}`}
                    onClick={() => {
                      if (showAll) handleShowAll && handleShowAll();
                    }}
                  >
                    {selectedtab !== "8" ? (
                      showAll ? (
                        <th>
                          {" "}
                          {
                            <Icon
                              className="icon-size"
                              icon="ic:outline-remove-red-eye"
                            />
                          }{" "}
                          All
                        </th>
                      ) : (
                        <th>Total</th>
                      )
                    ) : (
                      ""
                    )}
                    {tableDetails &&
                      tableDetails.map((item, idx) => {
                        if (item.isHeader && item.colSpan === 1) {
                          return (
                            <>
                              {showAll && selectedtab === "8" && idx === 3 && (
                                <td>
                                  {" "}
                                  {
                                    <Icon
                                      className="icon-size"
                                      icon="ic:outline-remove-red-eye"
                                    />
                                  }{" "}
                                  All
                                </td>
                              )}
                              {item.isHeader && idx > 0 && (
                                <td
                                  className={`${
                                    item.TypeOfData === "Price"
                                      ? "text-end pe-4"
                                      : item.TypeOfData === "Number" ||
                                        item.TypeOfData === "text-center"
                                      ? "text-center pe-4"
                                      : ""
                                  } ${item.isFixed ? "fixed-column" : ""}`}
                                >
                                  <span>
                                    {item.TypeOfData === "Price"
                                      ? "$" +
                                        (totalTableRow[item.DataKey]
                                          ? Number(totalTableRow[item.DataKey])
                                              .toFixed(2)
                                              .toString()
                                              .replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ","
                                              )
                                          : "0.00")
                                      : totalTableRow[item.DataKey]}
                                  </span>
                                </td>
                              )}
                            </>
                          );
                        }
                      })}
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="xs"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={reportList.length}
              limitOptions={Constants.pageLimit}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
      ) : // :
      // <></>
      DisplayNoDatatlabel ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "70vh" }}
        >
          <h5>NO DATA FOUND</h5>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default TableComponentforEquipment;
